import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './PopUp.scss';
import book from '../../Images/book.png'
import Image1Logo from '../../ImagesLogos/Image1Logo.png'
import closeMenu from '../../Images/closeMenu.png'
import Banner2Logo from '../../ImagesLogos/Banner2Logo.png'

export default function PopUp({ CitiePhone, CitiesData, setShowPopUp }) {
    const navigate = useNavigate()
    const location = useLocation()
    const url = new URL(window.location.href);

    return (
        <div className="PopUp">
            {url.pathname.includes('chimney') ?
                <div className="MainBanner">
                    <div className="MainBannerHeader">
                        <img onClick={() => {
                            localStorage.setItem("showPopUp", true);
                            setShowPopUp(false)
                        }
                        } src={closeMenu} alt="Air Duct Cleaning In Master, | Air Duct Repair In Master, | Air Duct Services In Master, | Air Duct Inspection In Master," />

                    </div>
                    <div className="MainBannerLeft">
                        <div className="MainBannerLeftLogo">
                            <img src={require(`../../ImagesLogos/Banner4Logo.png`)} />
                            {/* <h5>Master Air Duct Cleaning</h5> */}
                            <h6>{CitiesData && CitiesData.Full ? CitiesData.Full.toUpperCase() : "5 Star Air Duct Company"}</h6>
                        </div>
                        <h1>Schedule Your Chimney Service Today!</h1>
                        <h3><span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Chimney Inspections, Repair And Cleaning Near Me. (We also offer air duct and dryer vent services.)</h3>
                        <h2>Don't wait until it's too late! Ensure your chimney is safe and functioning efficiently.</h2>
                        <a href={`tel:${CitiePhone}`} onClick={() => {
                            localStorage.setItem("showPopUp", true);
                            setShowPopUp(false)
                        }}>Click To Call!</a>
                        <a onClick={() => {
                            localStorage.setItem("showPopUp", true);
                            navigate(`/book${location.search}?&service=chimney`)
                            setShowPopUp(false)
                        }}>SCHEDULE ONLINE<img src={book} alt="Air Duct Cleaning Near Me In Master" /></a>
                    </div>
                    <div className="MainBannerRight">
                        <img src={require(`../../ImagesLogos/Image2Logo.png`)} />
                        <div className="MainBannerRightBubble1"></div>
                        <div className="MainBannerRightBubble2"></div>
                    </div>
                </div>
                :
                <div className="MainBanner">
                    <div className="MainBannerHeader">
                        <img onClick={() => {
                            localStorage.setItem("showPopUp", true);
                            setShowPopUp(false)
                        }
                        } src={closeMenu} alt="Air Duct Cleaning In Master, | Air Duct Repair In Master, | Air Duct Services In Master, | Air Duct Inspection In Master," />

                    </div>
                    <div className="MainBannerLeft">
                        <div className="MainBannerLeftLogo">
                            <img src={require(`../../ImagesLogos/Banner4Logo.png`)} />
                            {/* <h5>Master Air Duct Cleaning</h5> */}
                            <h6>{CitiesData && CitiesData.Full ? CitiesData.Full.toUpperCase() : "5 Star Air Duct Company"}</h6>
                        </div>
                        <h1>Schedule Your Air Duct Service Today!</h1>
                        <h3><span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Air Duct & Dryer Vent Cleaning, Services And Repair Near Me</h3>
                        <h2>Don't wait until it's too late! Ensure your Air Duct is safe and functioning efficiently.</h2>
                        <a href={`tel:${CitiePhone}`} onClick={() => {
                            localStorage.setItem("showPopUp", true);
                            setShowPopUp(false)
                        }}>Click To Call!</a>
                        <a onClick={() => {
                            localStorage.setItem("showPopUp", true);
                            navigate(`/book${location.search}`)
                            setShowPopUp(false)
                        }}>SCHEDULE ONLINE<img src={book} alt="Air Duct Cleaning Near Me In Master" /></a>
                    </div>
                    <div className="MainBannerRight">
                        <img src={require(`../../ImagesLogos/Image2Logo.png`)} />
                        <div className="MainBannerRightBubble1"></div>
                        <div className="MainBannerRightBubble2"></div>
                    </div>
                </div>
            }
        </div>
    )
}
